module.exports = __webpack_public_path__ + "static/media/SFiOBOA_nn_engl_sekundaerlogo_postale_pos.54a89911.pdf";